module.exports = __webpack_public_path__ + "static/media/review-4.b5616c93.png";